export default "__VITE_ASSET__ac1e1f21__"